import { useState } from 'react'
import BigNumber from 'bignumber.js'
import styled from 'styled-components'
import { Token } from '@pulsex/sdk'
import { useTranslation } from '@pulsex/localization'
import { Flex, CardFooter, ExpandableLabel } from '@pulsex/uikit'
import { DeserializedPool } from '@pulsex/pools'
import ExpandedFooter from './ExpandedFooter'

interface FooterProps {
  pool: DeserializedPool<Token>
  account: string
  totalPlsxInVault?: BigNumber
  defaultExpanded?: boolean
}

const ExpandableButtonWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  button {
    padding: 0;
  }
`

const Footer: React.FC<FooterProps> = ({ pool, account, defaultExpanded }) => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(defaultExpanded || false)

  return (
    <CardFooter>
      <ExpandableButtonWrapper>
        <ExpandableLabel expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? t('Hide') : t('Details')}
        </ExpandableLabel>
      </ExpandableButtonWrapper>
      {isExpanded && <ExpandedFooter pool={pool} account={account} />}
    </CardFooter>
  )
}

export default Footer
